import Vue from 'vue';
import Vuetify, { VSnackbar, VBtn, VIcon } from 'vuetify/lib';
import VuetifyToast from 'vuetify-toast-snackbar';

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VIcon,
  },
});

Vue.use(VuetifyToast, {
  x: 'right', // default
  y: 'bottom', // default
  color: 'info', // default
  icon: 'mdi-information',
  iconColor: '', // default
  classes: [
      'body-2',
  ],
  timeout: 3000, // default
  dismissable: true, // default
  multiLine: false, // default
  vertical: false, // default
  queueable: true, // default
  showClose: true, // default
  closeText: '', // default
  closeIcon: 'mdi-close', // default
  closeColor: '', // default
  slot: [], // default
  shorts: {
    custom: {
      color: 'purple',
    },
    error: {
      // icon: 'mdi-skull-crossbones',
      icon: 'mdi-close-circle',
      color: 'error',
      showClose: true,
      timeout: 8000,
      x: 'right',
      y: 'top',
    },
    warning: {
      icon: 'mdi-alert',
      color: 'warning',
      x: 'right',
      y: 'top',
    },
    success: {
      icon: 'mdi-check',
      color: 'success',
    },
    edup: {
      icon: ['mdi-pistol', 'mdi-skull'],
      color: 'success',
    },
  },
  property: '$toast', // default
});

export default new Vuetify({
  components: {
    VSnackbar, // Imported explicitly to be compiled for the vuetify-toast-snackbar library.
    VIcon,
  },
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#00742d',
        secondary: '#044a64', // '#740047', //'#007467',
        accent: '#a01c00', // '#00A741', //'#0D7400',
        info: '#529200',
      },
    },
  },
});
